import React from 'react';
// Images
import MainImage1 from '../../assets/images/main/mistress-liyah-minx-your-king-bbw-ebony-dominatrix-huge-tits-sexy-boots.jpg';
import MainImage2 from '../../assets/images/main/mistress-liyah-minx-your-king-bbw-ebony-dominatrix-huge-tits-hot-pose.jpg';
// Constants
import { CompanyName, SESSIONS_PAGE_URL } from '../../utils/Constants';
// Components
import CallToActionOne from '../cta/CallToActionOne';
import WhatIOfferComponent from '../general/WhatIOfferComponent';
import SocialMediaCtaComponent from '../socialMedia/SocialMediaCtaComponent';

function AboutPageMainContainer() {
  return (
    <main role='main' className='pt-16'>
      {/* Bio Section */}
      <section className='grid mb-20'>
        <div className='grid lg:grid-cols-[1fr_2fr] lg:container lg:mx-auto gap-y-4 gap-x-6 px-8 sm:px-10 xl:gap-x-10 md:px-16 lg:px-10'>
          {/* Image */}
          <div className='my-auto'>
            <img
              src={MainImage1}
              alt={`${CompanyName} with neon diamond logo`}
              className='mx-auto object-cover md:max-h-[60vh] rounded neon_shadow'
              loading='lazy'
            />
          </div>

          {/* Artcile */}
          <article className='grid gap-4 pt-2'>
            {/* Header */}
            <section className='grid grid-cols-reg w-full gap-x-6 pt-4'>
              <div className='grid items-center'>
                <h3 className='text-3xl font-titleFont tracking-widest text-colour7'>
                  About Me
                </h3>
              </div>
              <div className='grid items-center'>
                <div
                  className='h-[2px] -mt-4 bg-colour7'
                  role='separator'
                  aria-hidden='true'
                ></div>
              </div>
            </section>
            {/* Main article */}
            {/* <section className='grid gap-2 text-center lg:text-left text-sm'>
              <p>
                Bow to your King 👑 — I’m Liyah Minx, your BBW ebony superior,
                sadistic seductress, and financial carnage aficionado. A big-tit
                ebony goth nightmare with a fat ass, I am the bringer of your
                financial ruin and femdom euphoria. Welcome to your favorite
                nightmare — a world of submission, servitude, and dedication.
                Once you’re under my spell, there’s no turning back. You’ll fall
                deeper down the rabbit hole and never want to leave.
              </p>

              <p>
                I have been honing my craft since 2015, blending intellect,
                safety, and a passion for the macabre into every session. My
                play style is rooted in SSC, RISK, RACK, and CCCC principles —
                safety and communication come first, always. I’m drawn to
                spooky, horror, and dark themes, bringing those energies into an
                immersive experience.
              </p>

              <p>
                My favorite kinks include{' '}
                <strong>
                  financial domination, sadistic mindfucking, cock play, pegging
                </strong>
                , and many more (ask me). But beware, I have hard limits — ⚠️ no
                sloppy, disrespectful behavior or bullshit tolerated.
              </p>

              <p>
                Address me as{' '}
                <strong>King, God, Superior, or Your Excellency</strong>. These
                titles reflect my power and authority. <strong>Do not</strong>{' '}
                call me Princess, Mistress, or anything less than what I
                deserve.
              </p>
            </section> */}
            <section className='grid gap-2 text-center lg:text-left text-sm'>
              <p>
                Kneel before your eternal King 👑. I am{' '}
                <strong>Liyah Minx</strong> — your voluptuous ebony divinity, a
                sadistic sorceress of souls, and the merciless arbiter of your
                financial and spiritual obliteration. A big-titted ebony goth
                wraith with curves that chain your essence to My altar, I am the
                harbinger of your ruin and the weaver of your euphoric
                enslavement. Enter My abyss — a relentless crucible of
                submission, worship, and eternal obsession. Once My gaze claims
                you, escape is a phantom you’ll never pursue.
              </p>

              <p>
                Since 2015, I have sculpted My dominion with lethal artistry,
                melding intellect, safety, and a macabre fervor into rituals
                that shatter your will and forge you anew. Rooted in{' '}
                <strong>SSC</strong> (Safe, Sane, Consensual),
                <strong> RACK</strong> (Risk-Aware Consensual Kink), and
                <strong> CCCC</strong> (Caring, Communication, Consent,
                Caution), My empire is a bastion of trust and dread. Infused
                with the spectral pulse of horror and dark majesty, My sessions
                are unholy sacraments that consume your very being.
              </p>

              <p>
                My sacred kinks —{' '}
                <strong>financial domination, sadistic mindfucking,</strong>,
                and a veiled constellation of others (plead to unveil them)—are
                My instruments of unraveling, wielded to bind you irrevocably to
                My will. But tread carefully: disrespect, sloppiness, or
                defiance will invoke My apocalyptic wrath.{' '}
                <strong>Cross Me, and you’ll be cast into oblivion.</strong>
              </p>

              <p>
                Address Me only as{' '}
                <strong>
                  King, God, Goddess, Superior, or Your Excellency
                </strong>{' '}
                — titles that resonate with My celestial dominion. Lesser names
                like Princess or Mistress are profane heresies, unfit for My
                presence. <strong>Prove your devotion now:</strong> spill your
                wealth, prostrate your soul, and dissolve into the divine
                maelstrom of My reign.{' '}
                <strong>
                  Falter, and the abyss will swallow you whole. Submit, for I am
                  the only truth you’ll ever know.
                </strong>
              </p>
            </section>
          </article>
        </div>
      </section>

      {/* Dom Section */}
      <section className='grid'>
        <div className='grid lg:grid-cols-[2fr_1fr] lg:container lg:mx-auto gap-y-4 gap-x-6 px-8 sm:px-10 xl:gap-x-10 md:px-16 lg:px-10'>
          {/* Artcile */}
          <article className='grid gap-4 pt-2'>
            {/* Header */}
            <section className='grid grid-cols-reg w-full gap-x-6'>
              {/* Large screen */}
              <div className='hidden md:grid items-center'>
                <h3 className='text-3xl font-titleFont tracking-widest text-colour7'>
                  My Life As A Domme
                </h3>
              </div>
              {/* Phone screen */}
              <div className='grid md:hidden items-center'>
                <h3 className='text-3xl font-titleFont tracking-widest text-colour7'>
                  My Life As <br /> A Domme
                </h3>
              </div>
              <div className='grid items-center'>
                <div
                  className='h-[2px] -mt-4 bg-colour7'
                  role='separator'
                  aria-hidden='true'
                ></div>
              </div>
            </section>

            {/* Main article */}
            {/* <section className='grid gap-2 text-center lg:text-left text-sm'>
              <p>
                I am <strong>King Liyah Minx</strong> — a superior BBW ebony
                goth seductress and sadistic mindfucker extraordinaire. Power is
                not just what I wield; it’s who I am. I command respect,
                obedience, and worship. If you are a submissive ready to serve,
                you are exactly where you belong — beneath Me.
              </p>

              <p>
                I offer a wide array of exclusive femdom, findom, and BDSM
                services online and IRL, tailored to your deepest desires. Every
                interaction is a step further into your financial and mental
                surrender, crafted on my terms.
              </p>

              <p>
                Real-life sessions are based in Central Indiana with travel
                available (subs pay expenses). Pricing starts at $250/hour with
                a 50% deposit required. Short-notice fees, add-ons like cock
                play ($50), pegging ($100), and filming options are available.
                Public cash meets start at $300.
              </p>

              <p>
                Online sessions require a $40 tribute and include voice calls
                ($5/min), text ($3/min), video calls ($8/min), plus custom
                content options like pictures ($25), videos ($40), clips ($50)
                with exclusivity fees as applicable.
              </p>

              <p>
                Respect, honesty, and devotion are mandatory. I expect my subs
                to complete tasks, communicate openly, and uphold my image. This
                is not a game; this is a lifestyle of financial and mental
                servitude.
              </p>

              <p>
                Ready to submit? Book a session or apply to serve. Your King
                awaits.
              </p>
            </section> */}
            <section className='grid gap-2 text-center lg:text-left text-sm'>
              <p>
                I am <strong>King Liyah Minx</strong> — your celestial BBW ebony
                goth divinity, a sadistic weaver of fates, and the eternal
                sovereign of your financial and psychic obliteration. Power is
                not My instrument; it is My very being, pulsing through every
                curve, every glance, every syllable of My will. I command
                absolute reverence, unwavering obedience, and fervent worship.
                If you are a submissive quaking with the urge to serve, you have
                found your sacred place — shattered at My feet, beneath My
                all-consuming gaze.
              </p>

              <p>
                My dominion is an unholy cathedral of femdom, findom, and BDSM
                rituals, offered online or in My divine presence, each a
                consecrated act to strip your soul bare and bind it to My
                eternal decree. Every moment under My rule is a plunge into the
                abyss of surrender, sculpted by My merciless hand.
              </p>

              <div className='grid w-full'>
                <a
                  href={SESSIONS_PAGE_URL}
                  className={`cursor-pointer text-xxs hover:bg-colour7 border-2 shadow-cardShadow border-solid border-colour7 bg-black w-full text-center h-fit py-2 mx-auto`}
                  aria-label={`sessions page link for more info`}
                >
                  See Sessions Section For More Info
                </a>
              </div>
              <p>
                Reverence, honesty, and devotion are My eternal edicts. You will
                execute My commands, bare your soul in sacred communion, and
                exalt My divine visage. This is no mortal pastime; it is a
                covenant of everlasting financial and mental servitude.
              </p>

              <p>
                Dare to surrender? Book your ritual or beg to serve.
                <strong>
                  Your King awaits, and defiance is a blasphemy I will not
                  forgive.
                </strong>
              </p>
            </section>
          </article>

          {/* Image */}
          <div className='my-auto pt-2'>
            <img
              src={MainImage2}
              alt={`${CompanyName} with her ass looking perfect`}
              className='mx-auto object-cover md:max-h-[60vh] rounded neon_shadow'
              loading='lazy'
            />
          </div>
        </div>
      </section>

      <div className='mt-12'>
        <CallToActionOne />
      </div>

      <WhatIOfferComponent />

      {/* Social cta */}
      <div className='pt-8'>
        <SocialMediaCtaComponent />
      </div>
    </main>
  );
}

export default AboutPageMainContainer;
